import axios from 'axios';
// import { UserIconData } from './Itemhunter';

// /**
//  * 아이콘 출력해도 됩니까?
//  */
// export async function callGetUserIconData(){
//   return await axios<UserIconData>({
//     method: 'get',
//     headers: {
//       'content-type': 'application/json',
//     },
//     responseType: 'json',
//     url: '/api/event/icons/findInfo',
//   });
// }

// /**
//  * 아이콘 클릭
//  */
// export async function callClikcItemIcom(data: Record<string, string>) {
//   let result = await axios<number>({
//     method: 'post',
//     headers: {
//       'content-type': 'application/x-www-form-urlencoded',
//     },
//     responseType: 'json',
//     url: '/api/event/icons/save',
//     // data: querystring.stringify(data as ParsedUrlQueryInput),
//     data: (new URLSearchParams(data)).toString(),
//   });

//   return result.data;
// }


/**
 * GET /api/event/icons/info
 */
export type RequestInfo = {
  eventCode: string
};

export type ResponseInfo = {
  idx:          number;
  eventCode:    string;
  gameName:     string;
  iconId:       number;
  iconName:     string;
  maxIconCount: number;
}[];


/**
 * 유저가 수집한 정보
 * GET /api/event/icons/logs
 */
export type RequestLogs = {
  eventCode: string
};
export type ResponseLogs = {
  iconId:       number;
  iconName:     string;
  maxIconCount: number;
  iconCount:    number;
}[];

export async function callGetUserIconData(domain: string, data: RequestLogs){
  return await axios<ResponseLogs>({
    method: 'get',
    headers: {
      'content-type': 'application/json',
    },
    withCredentials: true,
    responseType: 'json',
    url: `${domain}/api/event/icons/logs?eventCode=${data.eventCode}`,
  });
}


/**
 * 아이콘 클릭
 * POST /api/event/icons
 */

export type RequestIcons = {
  eventCode: string
  iconId: string
};
export type ResponseIcons = {
  iconId:       number;
  iconName:     string;
  maxIconCount: number;
  iconCount:    number;
}[];

export async function callClikcItemIcom(domain: string, data: RequestIcons) {
  let result = await axios<ResponseIcons>({
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
    responseType: 'json',
    url: `${domain}/api/event/icons`,
    // data: querystring.stringify(data as ParsedUrlQueryInput),
    data: (new URLSearchParams(data)).toString(),
  });

  return result.data;
}
